import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, onMounted } from 'vue'
import { getRouteTitle } from '../utils/routeUtils'
import { useRouter, RouteRecordNormalized, RouteLocationNormalizedLoaded, RouteRecordName } from 'vue-router'

interface Breadcrumb {
  text: string,
  to: {
    name?: RouteRecordName
  },
  exact: boolean
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const breadcrumbs = ref<Breadcrumb[]>([])
const parentRoutes = ref<RouteRecordNormalized[]>([])
const currentBreadcrumb = ref<string>()
const router = useRouter()

onMounted(() => {
  generateBreadcrumbs(router.currentRoute.value)
})

function addParentRoutes (routeName: string) {
  const parentRoute = router.getRoutes().find(route => route.name === routeName)

  if (parentRoute) {
    parentRoutes.value.push(parentRoute)

    if (parentRoute.meta.parent) {
      addParentRoutes(parentRoute.meta.parent as string)
    }
  }
}

function generateBreadcrumbs (to: RouteLocationNormalizedLoaded) {
  if (to.meta.parent) {
    addParentRoutes(to.meta.parent as string)
  }

  if (parentRoutes.value.length) {
    breadcrumbs.value = parentRoutes.value.reverse().map(foundRoute => {
      return {
        text: getRouteTitle(foundRoute, to),
        to: { name: foundRoute.name },
        exact: true,
      }
    })
  }

  currentBreadcrumb.value = getRouteTitle(to, to)
}

return (_ctx: any,_cache: any) => {
  const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el")!
  const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs")!

  return (_openBlock(), _createBlock(_component_q_breadcrumbs, {
    separator: ">",
    "separator-color": "grey",
    "active-color": "grey-darkest"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (breadcrumb) => {
        return (_openBlock(), _createBlock(_component_q_breadcrumbs_el, {
          key: breadcrumb.to.name,
          to: breadcrumb.to,
          label: breadcrumb.text
        }, null, 8, ["to", "label"]))
      }), 128)),
      (currentBreadcrumb.value)
        ? (_openBlock(), _createBlock(_component_q_breadcrumbs_el, {
            key: 0,
            label: currentBreadcrumb.value,
            class: "font-bold"
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})